import React, { useContext, useCallback, useState, useEffect } from 'react';
import { CurrentPageContext, useHistoryState } from 'app/home/general-components/HistoryStackContext';
import FullPageTransition from 'app/home/general-components/FullPageTransition';
import { useLocalizedStrings } from 'app/localization/Context';

import { SelectDevices, SelectBinds } from './pages/Selection';
import Overview from './pages/Overview + Detail';
import ChooseNameAndIcon from './pages/ChooseNameAndIcon';

import './CreateScenario.scss'

export default function CreateOrEditScenario({ gateway }) {
    const p = useContext(CurrentPageContext);
    const sc = useLocalizedStrings().createScenarioProcess;

    const editMode = p.state.editMode;
    const editScenarioBase = p.state.editScenarioBase;
    let _baseScenario = {
        device_actions: [],
        bind_states: [],
        pic_id: 1,
        name: sc.namePlaceHolders[1],
    };
    if (editMode === true) {
        _baseScenario = editScenarioBase;
    }

    const { delayedCurrentState, pushState, back, setLockState, numberOfStates } =
        useHistoryState(p.id, {
            pageData: {
                name: editMode ? 'overview' : 'select-devices',
                from: ''
            },
            intrestedDevice: null,
            intrestedBind: null,
        });
    const currentState = delayedCurrentState;

    const pageData = currentState.pageData;
    const intrestedDevice = currentState.intrestedDevice;
    const intrestedBind = currentState.intrestedBind;

    const setPageData = useCallback((v) => {
        pushState({
            pageData: v,
            intrestedDevice, intrestedBind
        });
    }, [pushState, intrestedDevice, intrestedBind]);
    const setIntrestedDevice = useCallback((v) => {
        pushState({
            intrestedDevice: v,
            pageData, intrestedBind
        });
    }, [pushState, pageData, intrestedBind]);
    const setIntrestedBind = useCallback((v) => {
        pushState({
            intrestedBind: v,
            pageData, intrestedDevice
        });
    }, [pushState, pageData, intrestedDevice]);

    const dismissHandler = useCallback(() => {
        setLockState(true);
        setTimeout(() => {
            back(true);
            setTimeout(() => { // fix a bug in safari: two consecutive backs will result in only perfoming the second one
                p.dismiss();
            });
        });
    }, [back, p, setLockState]);

    const [{ inverse }, setlastnNumberOfStates] = useState({ inverse: false, lastNumberOfStates: 0 });
    useEffect(() => {
        // console.log("numberOfStates", numberOfStates);
        setlastnNumberOfStates((x) => {
            return { inverse: numberOfStates < x.lastNumberOfStates, lastNumberOfStates: numberOfStates }
        })
    }, [numberOfStates]);

    const [deviceActions, setDeviceActions] = useState(_baseScenario.device_actions);
    const [bindStates, setBindStates] = useState(_baseScenario.bind_states);
    const [iconId, setIconId] = useState(_baseScenario.pic_id);
    const [name, setName] = useState(_baseScenario.name);

    const createCallback = useCallback(() => {
        gateway.createNewScenario({
            name: name,
            pic_id: iconId,
            device_actions: deviceActions,
            bind_states: bindStates
        });
    }, [name, iconId, deviceActions, bindStates, gateway]);

    const editCallback = useCallback(() => {
        gateway.editScenario({
            id: editScenarioBase.id,
            name: name,
            pic_id: iconId,
            device_actions: deviceActions,
            bind_states: bindStates
        });
    }, [editScenarioBase, name, iconId, deviceActions, bindStates, gateway]);

    return (
        <div className="create-scenario-page">
            <div className="bg-blank" />
            <div className="bg-secondary-color" />

            <FullPageTransition disableOnFirstTime inverse={inverse}>
                <SelectDevices
                    devices={gateway.devices}
                    deviceActions={deviceActions} setDeviceActions={setDeviceActions}
                    negotiatedProtocol={gateway.negotiatedProtocol}

                    dismissHandler={dismissHandler} back={back}
                    pageData={pageData} setPageData={setPageData}
                    intrestedDevice={intrestedDevice} setIntrestedDevice={setIntrestedDevice}
                    isVisible={pageData.name === "select-devices"}
                    key="create-scenario-select-devices" />

                <SelectBinds
                    binds={gateway.binds}
                    devices={gateway.devices}
                    scenarios={gateway.scenarios}
                    bindStates={bindStates} setBindStates={setBindStates}

                    dismissHandler={dismissHandler} back={back}
                    pageData={pageData} setPageData={setPageData}
                    intrestedBind={intrestedBind} setIntrestedBind={setIntrestedBind}
                    isVisible={pageData.name === "select-binds"}
                    key="create-scenario-select-binds" />

                <Overview
                    deviceActions={deviceActions} devices={gateway.devices}
                    bindStates={bindStates} binds={gateway.binds} scenarios={gateway.scenarios}

                    editMode={editMode} editCallback={editCallback}
                    setName={setName} name={name}
                    setIconId={setIconId} iconId={iconId}

                    dismissHandler={dismissHandler} back={back}
                    pageData={pageData} setPageData={setPageData}
                    isVisible={pageData.name === "overview"}
                    key="create-scenario-overview" />

                <ChooseNameAndIcon
                    setName={setName} name={name}
                    setIconId={setIconId} iconId={iconId}

                    dismissHandler={dismissHandler} back={back}
                    pageData={pageData} setPageData={setPageData}
                    createCallback={createCallback}
                    isVisible={pageData.name === "choose-name-and-icon"}
                    key="create-scenario-choose-name-and-icon" />
            </FullPageTransition>
        </div>
    )
}